// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOPIC_COUNSELLOR = "Odborn\u00edk";
